import React from 'react';
import { useNavigate, useParams } from 'react-router';
import { notification } from 'antd';

import { useAppDispatch, useAppSelector } from 'store';
import { IResortItem } from 'store/slices/resorts/interfaces';
import { MainLayout } from 'components/Layout/MainLayout';
import {
  loadResortItem,
  saveResortItem,
  saveResortItemAsDraft,
} from 'store/slices/resorts/actions';
import { StatusesEnum } from 'constants/status';

import { ResortsForm } from './components/ResortsForm';
import { mapValuesToForm } from './components/formUtils';

export const Edit = () => {
  const [isLoading, setIsLoading] = React.useState(false);
  const { item } = useAppSelector(state => state.resorts);
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const { id } = useParams();
  const { b2cUrl } = useAppSelector(state => state.configSlice);

  React.useEffect(() => {
    dispatch(loadResortItem(id));
  }, []);

  const onFinish = (values: IResortItem) => {
    setIsLoading(true);
    dispatch(saveResortItem({ ...values, id: item.id }))
      .unwrap()
      .then(() => {
        notification.success({
          message: 'Сущность успешно изменена',
        });
        navigate('/resorts');
      })
      .catch(() => setIsLoading(false));
  };

  const onSaveDraft = (values: IResortItem) => {
    setIsLoading(true);
    dispatch(saveResortItemAsDraft({ ...values, id: item.id }))
      .unwrap()
      .then(() => {
        notification.success({
          message: 'Сущность успешно изменена',
        });
        navigate('/resorts');
      })
      .catch(() => setIsLoading(false));
  };

  const cancelButtonHandler = () => {
    navigate('/resorts');
  };

  const getOgSiteName = () => {
    if (!item) return null;

    const sysName = item.sysName || '';
    const linkToB2C =
      item.lang === 'en'
        ? `${b2cUrl}/en/resorts/${id}/${sysName}`
        : `${b2cUrl}/resorts/${id}/${sysName}`;

    return linkToB2C;
  };

  return (
    <MainLayout pageTitle='Редактирование'>
      {item.id && item.id === Number(id) ? (
        <ResortsForm
          onFinish={onFinish}
          onSaveDraft={onSaveDraft}
          cancelButtonHandler={cancelButtonHandler}
          isDraft={item.status === StatusesEnum.DRAFT}
          isLoading={isLoading}
          initialValues={{
            ...mapValuesToForm(item),
            ogUrl: getOgSiteName(),
            ogSiteName: 'Посети Кавказ',
            ogType: 'resorts',
          }}
          itemId={item.id}
        />
      ) : null}
    </MainLayout>
  );
};
